/* eslint-disable react/destructuring-assignment */
import React, { useContext } from "react";
import { string, bool } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import { TransactionContext } from "pages/_components/TransactionCard/TransactionContext";
import CustomData from "pages/_components/CustomData/CustomData";

const EmitDebinSummaryBody = (props) => {
    const { transaction = {} } = useContext(TransactionContext);
    const { data = {} } = transaction;
    const {
        sellerName = props.sellerName,
        seller = props.seller,
        id = props.id,
        account = props.account,
        prestacion = props.prestacion,
        referencia = props.referencia,
        concepto = props.concepto,
        detalle = props.detalle,
    } = data;
    const { isTicket } = props;

    if (isTicket) {
        return <>ticket</>;
    }
    const debitAccountMask = account?.shortLabel ? `****${account?.shortLabel?.substring(1)}` : "";

    return (
        <GridTable className="form-summary">
            <GridTable.Container columns={3} rows={4}>
                <GridTable.Data>
                    <CustomData titleText="debin.id.recurency" titleTextType="I18N" valueText={id} />
                </GridTable.Data>
                <GridTable.Data columnStart={2} rowStart={1}>
                    <CustomData titleText="debin.dateExpitation" titleTextType="I18N" valueText={debitAccountMask} />
                </GridTable.Data>
                <GridTable.Data columnStart={3} rowStart={1}>
                    <CustomData
                        titleText="debin.seller"
                        titleTextType="I18N"
                        valueText={sellerName}
                        valueTextType="TEXT"
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={1} rowStart={2}>
                    <CustomData titleText="debin.seller.cuit" titleTextType="I18N" valueText={seller} />
                </GridTable.Data>
            </GridTable.Container>
            <GridTable.Container columns={3} rows={2}>
                <GridTable.Data>
                    <CustomData titleText="debin.service.label" titleTextType="I18N" valueText={prestacion} />
                </GridTable.Data>
                <GridTable.Data>
                    <CustomData titleText="debin.reference" titleTextType="I18N" valueText={referencia} />
                </GridTable.Data>
                <GridTable.Data>
                    <CustomData titleText="debin.concept.label" titleTextType="I18N" valueText={concepto} />
                </GridTable.Data>
                <GridTable.Data>
                    <CustomData titleText="debin.description.label" titleTextType="I18N" valueText={detalle} />
                </GridTable.Data>
            </GridTable.Container>
        </GridTable>
    );
};

EmitDebinSummaryBody.propTypes = {
    sellerName: string,
    seller: string,
    id: string,
    account: string,
    prestacion: string,
    referencia: string,
    concepto: string,
    detalle: string,
    isTicket: bool,
};

EmitDebinSummaryBody.defaultProps = {
    sellerName: "",
    seller: "",
    id: "",
    account: "",
    prestacion: "",
    referencia: "",
    concepto: "",
    detalle: "",
    isTicket: false,
};

export default EmitDebinSummaryBody;
